import api from 'api';

export const RECIPE_STEPS_ASYNC_ACTION_START = 'RECIPE_STEPS_ASYNC_ACTION_START';
export const RECIPE_STEPS_ASYNC_ACTION_ERROR = 'RECIPE_STEPS_ASYNC_ACTION_ERROR';
export const RECIPE_STEPS_ASYNC_UPDATE_ACTION_SUCCESS = 'RECIPE_STEPS_ASYNC_UPDATE_ACTION_SUCCESS';
export const RECIPE_STEPS_DRAGGABLE_UPDATE = 'RECIPE_STEPS_DRAGGABLE_UPDATE';
export const RECIPE_STEPS_OPTIONS_UPDATE = 'RECIPE_STEPS_OPTIONS_UPDATE';
export const RECIPE_STEPS_UPDATE_ORDINAL_SUCCESS = 'RECIPE_STEPS_UPDATE_ORDINAL_SUCCESS';
export const RECIPE_STEPS_ORDINAL_DEBOUNCE = 'RECIPE_STEPS_ORDINAL_DEBOUNCE';
export const RECIPE_STEPS_RESET_STATE = 'RECIPE_STEPS_RESET_STATE';

function recipeStepsAsyncActionStart() {
  return {
    type: RECIPE_STEPS_ASYNC_ACTION_START,
  };
}

function recipeStepsAsyncActionError(error) {
  return {
    type: RECIPE_STEPS_ASYNC_ACTION_ERROR,
    error,
  };
}

function recipeStepsAsyncUpdateSuccess(data) {
  return {
    type: RECIPE_STEPS_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

function recipeStepsUpdateOrdinalSuccess() {
  return {
    type: RECIPE_STEPS_UPDATE_ORDINAL_SUCCESS,
  };
}

export function resetRecipeStepsState() {
  return {
    type: RECIPE_STEPS_RESET_STATE,
  };
}

export function updateDraggableRecipeSteps(data) {
  return {
    type: RECIPE_STEPS_DRAGGABLE_UPDATE,
    data,
  };
}

export function updateRecipeStepsOptions(options) {
  return {
    type: RECIPE_STEPS_OPTIONS_UPDATE,
    options,
  };
}

export function getRecipeSteps(brandId, recipeId) {
  return (dispatch, getState) => {
    dispatch(recipeStepsAsyncActionStart());
    return api.request(`recipeStep/list?brandId=${ brandId }&recipeId=${ recipeId }`, 'get')
    .then((data) => {
      dispatch(recipeStepsAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(recipeStepsAsyncActionError('Unable to get recipe steps'));
      throw (err);
    });
  };
}

export function updateRecipeStepsOrdinal(orderedRecipeSteps) {
  const thunk = (dispatch, getState) => {
    
    return api.request('recipeStep/updateOrdinalsByIndex', 'put', orderedRecipeSteps)
    .then((data) => {
      dispatch(recipeStepsUpdateOrdinalSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(recipeStepsAsyncActionError('Unable to order recipe steps'));
      throw (err);
    });
  };
  thunk.meta = {
    debounce: {
      time: 500,
      key: RECIPE_STEPS_ORDINAL_DEBOUNCE,
    },
  };
  return thunk;
}
